import { ShareNetwork } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useRevokeShare, useShares } from "~/api/queries";
import { Button } from "~/foundation/components/Button";
import { Empty } from "~/foundation/components/Empty";
import { Spinner } from "~/foundation/components/Spinner";
import { Text } from "~/foundation/components/Text";
import { formatRelativeTime } from "~/foundation/utils/time";

export function Shares() {
  const { t, i18n } = useTranslation();
  const { data: shares, isLoading } = useShares();
  const revoke = useRevokeShare();

  if (isLoading) {
    return <Spinner label={t("Loading")} />;
  }
  if (!shares?.length) {
    return <Empty icon={ShareNetwork} message={t("Nothing is shared publicly")} />;
  }

  return (
    <div className="flex flex-col gap-3">
      <Text variant="small">
        {t("Anyone with one of these links can read the document without signing in.")}
      </Text>

      <ul className="flex flex-col rounded-md border border-divider">
        {shares.map((share) => (
          <li
            key={share.id}
            className="flex items-center gap-3 border-b border-divider px-3 py-2.5 last:border-b-0"
          >
            <div className="min-w-0 flex-1">
              <p className="truncate text-body text-text">{share.documentTitle}</p>
              <p className="truncate font-mono text-small text-text-tertiary">{share.url}</p>
            </div>
            <span className="hidden text-small text-text-tertiary sm:inline">
              {t("{{count}} views", { count: share.views })}
            </span>
            <span className="hidden text-small text-text-tertiary md:inline">
              {formatRelativeTime(share.createdAt, i18n.language)}
            </span>
            <Button
              size="sm"
              variant="ghost"
              disabled={revoke.isPending}
              onClick={() =>
                revoke.mutate(share.id, {
                  onSuccess: () => toast.success(t("Link revoked")),
                })
              }
            >
              {t("Revoke")}
            </Button>
          </li>
        ))}
      </ul>
    </div>
  );
}
